import http from "../../http";

/** 居家维修价目 — /resident/api/resident/houseRepairPrice */
const BASE = "/resident/api/resident/houseRepairPrice";

export default {
  selectPage(r) {
    return http.get(`${BASE}/page`, r);
  },
  selectById(r) {
    return http.get(`${BASE}/detail`, r);
  },
  save(r) {
    return http.payload(`${BASE}/save`, r);
  },
  submitAudit(r) {
    return http.tip.post(`${BASE}/submitAudit`, r);
  },
  auditPass(r) {
    return http.confirm.payload(`${BASE}/audit`, { ...r, pass: true });
  },
  audit(r) {
    return http.payload(`${BASE}/audit`, r);
  },
  publish(r) {
    return http.tip.post(`${BASE}/publish`, r);
  },
  updateStatus(r) {
    return http.tip.post(`${BASE}/updateStatus`, r);
  },
  updateSortNo(r) {
    return http.tip.post(`${BASE}/updateSortNo`, r);
  },
};
